import { createAction } from '../store.model';

import { PerformanceCard } from './models/performance-card.model';

export enum ActionType {
    MY_PERFORMANCE_CARD__ROOT__RELOAD = 'MY_PERFORMANCE_CARD__ROOT__RELOAD',
    MY_PERFORMANCE_CARD__ROOT__RELOAD_RESULT = 'MY_PERFORMANCE_CARD__ROOT__RELOAD_RESULT',
    MY_PERFORMANCE_CARD_SELECT_PILLAR_ACTION = 'MY_PERFORMANCE_CARD_SELECT_PILLAR_ACTION',
    MY_PERFORMANCE_CARD_ROOT__CLEAR_STATE = 'MY_PERFORMANCE_CARD_ROOT__CLEAR_STATE',
    MY_PERFORMANCE_CARD_TOGGLE_PILLAR_COLLAPSE = 'MY_PERFORMANCE_CARD_TOGGLE_PILLAR_COLLAPSE',
    MY_PERFORMANCE_CARD__GET_PERFORMANCE_DATA = 'MY_PERFORMANCE_CARD__GET_PERFORMANCE_DATA',
    MY_PERFORMANCE_CARD__GET_PERFORMANCE_DATA_RESULT = 'MY_PERFORMANCE_CARD__GET_PERFORMANCE_DATA_RESULT',
    MY_PERFORMANCE_CARD__GET_METRIC_PERFORMANCE_DATA = 'MY_PERFORMANCE_CARD__GET_METRIC_PERFORMANCE_DATA',
    MY_PERFORMANCE_CARD__GET_METRIC_PERFORMANCE_DATA_RESULT = 'MY_PERFORMANCE_CARD__GET_METRIC_PERFORMANCE_DATA_RESULT',
}
export interface RootReloadAction {
    userId: number;
    triggeredFromRoot: boolean;
}

export const reload = createAction<ActionType, RootReloadAction>(
    ActionType.MY_PERFORMANCE_CARD__ROOT__RELOAD,
);
export interface ReloadResultAction extends RootReloadAction {
    performanceCard?: PerformanceCard;
}

export const reloadResult = createAction<ActionType, ReloadResultAction>(
    ActionType.MY_PERFORMANCE_CARD__ROOT__RELOAD_RESULT,
);
export interface SelectActionAction {
    userId: number;
    colorGroup?: string;
    isParentPillar?: boolean;
}

export const selectPillarAction = createAction<ActionType, SelectActionAction>(
    ActionType.MY_PERFORMANCE_CARD_SELECT_PILLAR_ACTION,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootClearStateAction {}

export const clearState = createAction<ActionType, RootClearStateAction>(
    ActionType.MY_PERFORMANCE_CARD_ROOT__CLEAR_STATE,
);
